module.exports = __webpack_public_path__ + "img/scooter-unlocked-2x.a02dfdc1.png";